import "./App.scss";
import { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import LandingPage from "./Pages/LandingPage/LandingPage";
import Dashboard from "./Pages/LandingPage/Dashboard";
import Login from "./Pages/Login/Login";
import { Flow } from "./utils/flow";
import authenticationService from "./services/authenticationService";
import jsUtils from "./utils/jsUtils";
import { CircularProgress } from "@mui/material";
import ToastMessage, { MESSAGE_TYPE } from "./components/ToastMessage";
import axios from "axios";
import config from "./config";

function App() {
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [flow, setFlow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("error");
  const navigate = useNavigate();

  const getSamlResponse = async (flowId, sid) => {
    await authenticationService
      .samlResume(flowId, sid)
      .then((response) => {
        if (
          response?.data &&
          !(response?.data instanceof Error) &&
          response?.data?.data
        ) {
          let htmlFormat = response?.data?.data;
          htmlFormat = htmlFormat
            .replace(/'/g, "'")
            .replace(/"/g, '"')
            .replace(/\r\t/g, "")
            .replace(/\r\n/g, "")
            .replace(/\n/g, "");
          document.open();
          document.write(htmlFormat);
          document.close();
        } else {
          // console.log("error fetching saml response");
          setUserLoggedIn(true);
          if (window.location.href?.split("?")?.[1] === "isAuthorized=false") {
            navigate("/");
          }
          window.history.replaceState({}, "", "/");
        }
      })
      .catch(() => {
        // console.log("error fetching saml response");
      });
  };
  const onLoginSuccess = async (sid, timeOut = "", samlFlowIdFromStore) => {
    localStorage.setItem("sid", sid);
    localStorage.setItem("timeOut", timeOut);
    sessionStorage.setItem("timeOut", timeOut);
    localStorage.setItem("isAuthorized", true);

    //console.log('SID being sent to Parent');
    const sidInfo = {
      sid: sid,
    };

    //window.opener.postMessage(sidInfo, '*'); //Need to change the target window in QA and above
    const popup = window.opener;
    //const urlPath = (window.location != window.parent.location) ? document.referrer: document.location;
    if (popup) {
      if (config.addInDomainUrl) {
        popup.postMessage(sidInfo, `${config.addInDomainUrl}`);
      }
    }
    // else{
    //   // window.postMessage(sidInfo, 'https://localhost:3000');
    //   window.postMessage(sidInfo, `${config.addInDomainUrl}`);
    // }
    const TargetUrlPresent = checkTargetUrl();
    if (TargetUrlPresent) {
      // Open target URL in a new tab with SID
      window.open(TargetUrlPresent, "_self");
      setUserLoggedIn(true);
    } else {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const flowId = urlParams.get("flowId") || samlFlowIdFromStore;
      if (flowId && flowId !== "undefined") {
        getSamlResponse(flowId, sid);
      } else {
        setUserLoggedIn(true);
        if (window.location.href?.split("?")?.[1] === "isAuthorized=false") {
          navigate("/");
        }
        window.history.replaceState({}, "", "/");
      }
    }
  };

  const updateFlow = (_flow) => {
    setFlow(new Flow(_flow));
  };

  const handleClose = () => {
    setMessage("");
  };

  const showToastMessage = (message, type = MESSAGE_TYPE.ERROR) => {
    setMessage(message);
    setMessageType(type);
  };

  const getAllParams = () => {
    const decodedLink = window.location.search;
    const decodedParams = new URLSearchParams(decodedLink);

    let paramsObj = {};
    let sidCount = 0; // Initialize counts for sid and gmt_offset
    let gmtOffsetCount = 0;

    // Collect all parameters from the main URL (excluding target_url)
    decodedParams.forEach((value, key) => {
      if (key === "sid") {
        sidCount++;
        paramsObj[`sid_${sidCount}`] = value; // Add unique key for sid
      } else if (key === "gmt_offset") {
        gmtOffsetCount++;
        paramsObj[`gmt_offset_${gmtOffsetCount}`] = value; // Add unique key for gmt_offset
      } else if (key !== "target_url") {
        paramsObj[key] = value; // For other params, add them normally
      }
    });

    // Extract and parse target_url parameter if it exists
    const targetUrl = decodedParams.get("target_url");
    if (targetUrl) {
      const trimmedTargetUrl = targetUrl.trim(); // Trim any unwanted spaces
      const urlObj = new URL(trimmedTargetUrl); // Create a new URL object to parse the query string
      const targetParams = new URLSearchParams(urlObj.search); // Parse the query parameters of target_url

      // Collect parameters from the target_url
      targetParams.forEach((value, key) => {
        if (key === "sid") {
          sidCount++;
          paramsObj[`sid_${sidCount}`] = value; // Add unique key for sid from target_url
        } else if (key === "gmt_offset") {
          gmtOffsetCount++;
          paramsObj[`gmt_offset_${gmtOffsetCount}`] = value; // Add unique key for gmt_offset from target_url
        } else {
          paramsObj[key] = value; // For other params, add them normally from target_url
        }
      });
    }

    // Include counts of sid and gmt_offset in the result object
    paramsObj.sidCount = sidCount;
    paramsObj.gmtOffsetCount = gmtOffsetCount;

    return paramsObj;
  };

  const checkTargetUrl = () => {
    const decodedLink = window.location.search;
    const decodedParams = new URLSearchParams(decodedLink);

    // Retrieve the target_url parameter
    const isTargetUrlParam = decodedParams.get("target_url");

    if (isTargetUrlParam) {
      let targetUrl = isTargetUrlParam.trim(); // Remove any spaces at the beginning or end
      const allParams = getAllParams(); // Fetch all query parameters

      // Step 1: Check if there are multiple 'sid' or 'gmt_offset' parameters
      const sidCount = allParams.sidCount;
      const gmtOffsetCount = allParams.gmtOffsetCount;

      // If more than one 'sid' or 'gmt_offset' found, return early with a message or null
      if (sidCount > 0 || gmtOffsetCount > 0) {
        // console.error("Multiple sid or gmt_offset parameters detected.");
        return null;
      }

      // Check if target_url already contains query parameters
      // Step 3: Add sid and gmt_offset if missing
      const sid = encodeURIComponent(localStorage.getItem("sid"));
      const gmtOffset = encodeURIComponent(jsUtils.getGMTOffset());

      // Step 4: Check if '?' already exists in the targetUrl
      if (targetUrl.indexOf("?") === -1) {
        // If no query parameters exist, append '?' to start the query string
        targetUrl += "?";
      } else {
        // If '?' is already present, append '&' to add new parameters
        targetUrl += "&";
      }

      // Append sid and gmt_offset as new query parameters
      targetUrl += `sid=${sid}&gmt_offset=${gmtOffset}`;

      // Return the modified target_url with the new parameters
      return targetUrl;
    }

    // If target_url doesn't exist in the query string, return null
    return null;
  };

  useEffect(async () => {
    //handle auto logout in case of 401/403
    if (window.location.href?.split("?")?.[1] === "isAuthorized=false") {
      if (sessionStorage.getItem("timeoutId")) {
        clearInterval(sessionStorage.getItem("timeoutId"));
      }
      localStorage.clear();
      sessionStorage.clear();
      setUserLoggedIn(false);
      navigate("/");
    } else if (jsUtils.getUrlParameters(window.location.href)?.["code"]) {
      setLoading(true);
      let code = jsUtils.getUrlParameters(window.location.href)?.["code"];
      let appId = jsUtils.getUrlParameters(window.location.href)?.["appid"];
      const flowId = localStorage.getItem("samlFlowId");
      let payload = { code: code };
      if (appId) {
        payload["appId"] = appId;
      }
      await axios
        .post(`${config.ssoApiBaseUrl}/sso/v2/login/code`, payload, {
          withCredentials: true,
        })
        .then((response) => {
          // console.log("log user in");
          if (response.data && !(response.data instanceof Error)) {
            if (response.data?.data?.mobileDeeplink) {
              window.location.replace(response.data?.data?.mobileDeeplink);
            } else {
              window.history.replaceState({}, "", "/");
              localStorage.removeItem("samlFlowId");
              onLoginSuccess(
                response.data?.data?.sid,
                response.data?.data?.timeOut,
                flowId,
              );
            }
          } else {
            showToastMessage("invalid code");
            // console.log("not a valid code");
          }
        })
        .catch(() => {
          // console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (
      localStorage.getItem("sid") &&
      localStorage.getItem("isAuthorized")
    ) {
      const queryString = window.location.search;
      const TargetUrlPresent = checkTargetUrl();
      if (TargetUrlPresent) {
        // Open target URL in a new tab with SID
        window.open(TargetUrlPresent, "_self");
        setUserLoggedIn(true);
      } else {
        const urlParams = new URLSearchParams(queryString);
        const flowId = urlParams.get("flowId");
        if (flowId) {
          window.history.replaceState({}, "", "/");
          getSamlResponse(flowId, localStorage.getItem("sid"));
        } else {
          let timeOut = localStorage.getItem("timeOut");
          if (timeOut && Number(timeOut)) {
            sessionStorage.setItem("timeOut", timeOut);
          }
          window.history.replaceState({}, "", "/");
          setUserLoggedIn(true);
        }
      }
    } else {
      setUserLoggedIn(false);
    }
  }, []);

  return (
    <div data-testid="App">
      <ToastMessage
        message={message}
        type={messageType}
        onClose={handleClose}
      />
      {loading ? (
        <CircularProgress
          sx={{ display: "block", position: "fixed", top: "50%", right: "50%" }}
        />
      ) : userLoggedIn ? (
        <Routes>
          <Route
            path="/landing"
            element={<LandingPage setUserLoggedIn={setUserLoggedIn} />}
          />
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route
            path="/"
            element={<LandingPage setUserLoggedIn={setUserLoggedIn} />}
          />
        </Routes>
      ) : (
        <Login
          onLoginSuccess={onLoginSuccess}
          setUserLoggedIn={setUserLoggedIn}
          parentFlow={flow}
          updateFlow={updateFlow}
        />
      )}
    </div>
  );
}

export default App;
